import { ProjectWithMetadata } from "@nova/constants"
import { createIconKMZ } from "@nova/data-create-icon-kml"
import { Icon } from "@nova/protobuf"
import { iconFeatures } from "./caltopo"

export const iconTransformer = (icon: Icon, project: ProjectWithMetadata) => {
    return {
        iconToKMZ: async () => {
            return await createIconKMZ(icon)
        },
        iconToCalTopo: () => iconFeatures(icon),
        entity: icon,
        project,
    }
}
